/* unplugin-vue-components disabled */import script from "./MessageList.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageList.vue?vue&type=script&setup=true&lang=js"

import "./MessageList.vue?vue&type=style&index=0&id=2354f776&lang=less&scoped=true"

import exportComponent from "/Users/zhaoshunchen/Desktop/job/sinosig/workspace/shuke/sinosig-app-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2354f776"]])

export default __exports__